export const PROCTOR_ACTION = 'proctorAction';
export const ABORT_LAUNCH = 'abortLaunch';
export const DUPLICATE_LOGIN = 'duplicateLogin';
export const PROCTOR_ACTION_LAUNCH = 'LAUNCH';
export const PROCTOR_ACTION_ERROR= 'ERROR';
export const PROCTOR_ACTION_PAUSE = 'PAUSE';
export const PROCTOR_ACTION_RESUME = 'RESUME';
export const PROCTOR_ACTION_SAVEANDEXIT = 'SAVEANDEXIT';
export const PROCTOR_ACTION_SUBMITANDEXIT = 'SUBMITANDEXIT';
export const PROCTOR_ACTION_TERMINATE = 'TERMINATE';